import AzureSlice from './azure.slice';

export const { actions: azure_actions } = AzureSlice;

export default AzureSlice.reducer;
